import { Map, fromJS } from "immutable";
import { FETCH_CATEGORIES_SUCCESS } from "./actions";

export default function FindCE(state = Map(), action) {
  switch (action.type) {
    case FETCH_CATEGORIES_SUCCESS:
      return state.set("categories", fromJS(action.data));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/screens/FindCE/redux/reducer.js